module.exports = __webpack_public_path__ + "Icono_Chat_Blanco_512px.png";